import React from "react";
import { Box } from "@mui/material";
import About from "../../components/About";
import Education from "../../components/Education";
import Experience from "../../components/Experience";
import Testimonials from "../../components/Testimonials";
import Footer from "../../components/Footer";
import Header from "../../components/Header";

function App() {
  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
    >
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Header />
        <About />
        <Education />
        <Experience />
        <Testimonials />
      </Box>
      <Footer />
    </Box>
  );
}

export default App;
